import InherentRisksControls from './InherentRisksControls';
export default InherentRisksControls;
